<template>
  <p
    class="e-button"
    @click="_click()"
    :style="{ width: width + 'px', height: height + 'px', lineHeight: height + 'px' }"
    :class="[`${pattern}-${type}`, disabled ? 'is-disabled' : '']"
  >
    <slot>
      {{ label }}
    </slot>
  </p>
</template>

<style lang="less" scoped>
.e-button {
  margin: 10px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
}
.e-button.is-disabled {
  cursor: not-allowed;
  background-image: none;
  opacity: 0.6;
}

.fullfill-primary {
  background: #0975e0ff;
  color: #ffffff;
}

.fullfill-gray {
  background: #e4e4e4;
  color: #747474;
}

.loop-primary {
  border: 1px solid #0975e0ff;
  color: #0975e0ff;
  background: #ffffff;
}

.pierced-primary {
  background: #ffffff;
  color: #363636;
  border: 1px solid #f0f0f0;
}
</style>

<script>
export default {
  name: 'EButton',
  props: {
    width: {
      type: Number,
      default: 160,
    },
    height: {
      type: Number,
      default: 40,
    },
    label: {
      type: String,
      default: '',
    },
    pattern: {
      type: String,
      default: 'fullfill',
    },
    type: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    _click() {
      if (this.disabled) return
      this.$emit('click')
    },
  },
}
</script>
